import React from 'react'

import { PageLink } from 'src/components/link'
import BlockContent from "@sanity/block-content-to-react"

import { Serializer } from "src/utils/serializer"

export interface TwoColumnProps {
  data: {
    textBlocks: []
  }
}

export const TwoColumn = ({ data }: TwoColumnProps) => {
  const {
    textBlocks
  } = data
  return (
    <div className="container--xl outer mxa p05 two-text s1 al x">
      <div className='f jcb fw ais caps'>
        {textBlocks && textBlocks.map((block: { _key: string, text: any[] }) => (
          <div key={block._key} className='x c50'>
            <BlockContent blocks={block.text} serializers={Serializer} />
          </div>
        ))}
      </div>
      <div className='ac m1'>
        <PageLink to='/' className='mr1 button px05 s20 button--border caps'>
          <span>Back to Site</span>
        </PageLink>
      </div>
    </div>
  )
}